import { Fv, About, Problem, Service, Banner, Flow, LinkBanner, News } from "../components/Project";
import { Grid, Space } from "../components/Layout";
import { Media, ScrollTop } from "../components/Object";

const Home = () => {

  return (
    <>
      <Fv></Fv>
      <Space size={['120px 0 96px', '80px 0 64px']}>
        <About />
      </Space>

      {/* Ploblem */}
      <Space size={['0 0 120px', '0 0 80px']}>
        <Problem />
        <Space size={['64px 0 0', '48px 0 0']}>
          <Media src="common/bottom-text-problem" alt=" " class="p-img__back-text" />
        </Space>
      </Space>
    
      {/* Service */}
      {/* <Space> */}
        <Service />
      {/* </Space> */}
    
      <Space size={['72px 0 120px', '64px 0 80px']}>
        <Banner />
      </Space>

      <Space size={['0 0 160px', '0 0 100px']}>
        <Flow />
        <Space size={['64px 0 0', '48px 0 0']}>
          <Media src="common/bottom-text-problem" alt=" " class="p-img__back-text" />
        </Space>
      </Space>

      <LinkBanner />

      <News />

      <ScrollTop></ScrollTop>

    </>
  );
};

export default Home;
